'use client';

import React from 'react';
import { useField } from 'formik';
import { InputProps } from '../../common/interfaces';

export const Textarea = ({
  type = 'text',
  size = 'default',
  label,
  value = '',
  placeholder,
  isDisabled = false,
  onChange,
  ...props
}: InputProps) => {
  const stylesList: string[] = [
    'bg-white text-slate-900 disabled:bg-slate-50 disabled:text-slate-500 disabled:ring-slate-200 block border w-full rounded-lg sm:leading-6' +
      ' disabled:cursor-not-allowed p-4',
  ];
  const [field, meta] = useField(props);

  return (
    <div className="flex flex-col">
      {label && (
        <div className="block -mb-3 z-10 ml-1.5">
          <label
            htmlFor={field.name}
            className={[
              'text-xs font-medium text-slate-800 leading-6 px-2',
              isDisabled
                ? 'bg-slate-50 rounded-md border border-slate-300'
                : 'bg-white',
            ].join(' ')}
          >
            {label}
          </label>
        </div>
      )}

      <textarea
        {...field}
        {...props}
        rows={3}
        name={field.name}
        className={[
          stylesList.join(' '),
          meta.touched && meta.error ? ' border-red-500' : 'border-slate-300',
        ].join(' ')}
        placeholder={placeholder}
        disabled={isDisabled}
      />

      {meta.touched && meta.error ? (
        <p className="mt-1 text-xs text-red-500 flex-wrap">{meta.error}</p>
      ) : null}
    </div>
  );
};
